<template>
  <v-main >
    <v-layout row wrap class="ma-2">
      <v-flex xs12 sm12 lg12>
        <v-card class="rounded-xl">
          <div class="example">
            <apexcharts
              class="pa-2"
              type="bar"
              :options="chartOptionsSenhasGeradas"
              :series="seriesSenhasGeradas"
            ></apexcharts>
          </div>
          <v-card-text class="white--text pt-2 cyan darken-2 text-center">
            <div class="headline">Gráfico de senhas geradas por serviço</div>
            <v-divider class="my-2"></v-divider>
            <v-icon class="mr-2" small>mdi-clock</v-icon>
            <span
              class="caption white--text font-weight-light"
            >Último registro à {{textTempoAtualizado}} atrás</span>
          </v-card-text>
          <!-- <v-card-actions class="justify-center cyan darken-2"></v-card-actions> -->
        </v-card>
      </v-flex>

    </v-layout>

  </v-main>
</template>

<script>
import Cookies from 'js-cookie'
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'
import administradorUnidadeService from '../../../services/administradorUnidade.service'
import socketService from '../../../services/socket.service'
import { getToken } from '../../../store/auth'

export default {
  components: {
    apexcharts: VueApexCharts
  },
  data () {
    return {
      senhasGeradas: [],
      quantatendimentosStatus: [],
      textTempoAtualizado: '',
      intervalRegistroSocket: '',
      chartOptionsSenhasGeradas: {
        chart: {
          id: 'vuechart-senhasGeradas',
          height: 300
        },
        noData: {
          text: 'Carregando...'
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: []
        }
      },
      seriesSenhasGeradas: [
        {
          name: '',
          data: []
        }
      ],
      arrayChartSenhasGeradas: [],
      chartSenhasGeradas: null,
      chartAtendimentoStatus: null,
      dadosGrafico: []
    }
  },

  mounted () {
    console.log('em mounted AdminUnidade..')
    this.user = this.$store.getters.usuario
    if (this.user.tipo != 5) {
      this.$router.push('/login')
      return
    }
    this.socket = io.connect(socketService.SOCKET_URL, {
      query: {
        token: getToken()
      }
    })
    this.chamarSocket()
    this.registrarTempoSocket()
  },

  created () {
    console.log('created...')
    this.retornarQuantSenhasGeradas()
    // this.retornarQuantAtendimentoStatus();
  },
  methods: {
    retornarQuantSenhasGeradas () {
      administradorUnidadeService.administradorUnidade
        .retornarQuantSenhasGeradas()
        .then(rsp => {
          console.log('rsp retornarQuantSenhasGeradas:', rsp.data)
          this.senhasGeradas = rsp.data
          var series = []
          var categories = []
          this.senhasGeradas.forEach(element => {
            series.push(element.senhasGeradas)
            categories.push(element.nomeEspecialidade)
          })

          var tamanho = series.length
          this.seriesSenhasGeradas = [
            {
              data: series
            }
          ]
          this.chartOptionsSenhasGeradas = {
            xaxis: {
              categories: categories
            },
            chart: {
              height: 200 + 8 * tamanho
            }
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarQuantAtendimentoStatus () {
      administradorUnidadeService.administradorUnidade
        .retornarQuantAtendimentoStatus()
        .then(rsp => {
          console.log('rsp retornarQuantAtendimentoStatus:', rsp.data)
          this.quantatendimentosStatus = rsp.data

          var series = []
          var categories = []
          this.quantatendimentosStatus.forEach(element => {
            series.push(element.quantAtendimento)
            categories.push(element.status)
          })

          ApexCharts.exec(
            'chartQuantAtendimentosStatus',
            'updateOptions',
            {
              series: [
                {
                  data: series
                }
              ],
              xaxis: {
                categories: categories
              }
            },
            true,
            true
          )
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    chamarSocket () {
      this.socket.on(
        'novaFichaGerada',
        function (mensagem) {
          console.log('skt novaFichaGerada', mensagem)
          var series = []
          var categories = []

          mensagem.forEach(elementSocket => {
            var indexSenhaGerada = this.senhasGeradas.findIndex(
              element => element.nomeEspecialidade == elementSocket.nomeServico
            )
            console.log('index encontrado', indexSenhaGerada)
            if (indexSenhaGerada == -1) {
              // n encontrou
              var element = {
                nomeEspecialidade: elementSocket.nomeServico,
                senhasGeradas: 1
              }
              this.senhasGeradas.push(element)
            } else {
              this.senhasGeradas[indexSenhaGerada].senhasGeradas =
                this.senhasGeradas[indexSenhaGerada].senhasGeradas + 1
            }
          })
          this.senhasGeradas.forEach(element => {
            series.push(element.senhasGeradas)
            categories.push(element.nomeEspecialidade)
		  })

          var tamanho = series.length
          this.seriesSenhasGeradas = [
            {
              data: series
            }
          ]
          this.chartOptionsSenhasGeradas = {
            xaxis: {
              categories: categories
            },
            chart: {
              height: 200 + 8 * tamanho
            }
          }
          this.registrarTempoSocket()
        }.bind(this)
      )
    },

    registrarTempoSocket () {
      var date = new Date()
      var finaltime = timeSince(date)
      clearInterval(this.intervalRegistroSocket)
      this.intervalRegistroSocket = setInterval(
        function () {
          this.textTempoAtualizado = timeSince(date)
        }.bind(this),
        30000
      )
      this.textTempoAtualizado = timeSince(date)

      function timeSince (date) {
        var seconds = Math.floor((new Date() - date) / 1000)
        var interval = Math.floor(seconds / 31536000)

        if (interval > 1) {
          return interval + ' anos'
        }
        interval = Math.floor(seconds / 2592000)
        if (interval > 1) {
          return interval + ' mêses'
        }
        interval = Math.floor(seconds / 86400)
        if (interval > 1) {
          return interval + ' dias'
        }
        interval = Math.floor(seconds / 3600)
        if (interval > 1) {
          return interval + ' horas'
        }
        interval = Math.floor(seconds / 60)
        if (interval >= 1) {
          return interval + ' minutos'
        }
        return Math.floor(seconds) + ' segundos'
      }
    }
  }
}
</script>

<style  scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 30px;
  right: 20px;
}

.v-sheet--offset {
  top: -0px;
  position: relative;
}

@import url(https://fonts.googleapis.com/css?family=Roboto);

body {
  font-family: Roboto, sans-serif;
}

#chartSenhasGeradas {
  margin: 300px auto;
}
</style>
